import { render, staticRenderFns } from "./MentionMoneyVerifyModal.vue?vue&type=template&id=9d865770&scoped=true"
import script from "./MentionMoneyVerifyModal.vue?vue&type=script&lang=js"
export * from "./MentionMoneyVerifyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d865770",
  null
  
)

export default component.exports